import AjaxComponentLoader from 'utils/ajax_component_loader';

export default class ActivityCommentsList {
  static getList(activityId, page = 1) {
    return AjaxComponentLoader.load({
      component: 'timeline/activity_comments_list',
      type: 'page_component',
      data: {
        activity_id: activityId
      },
      params: {page}
    });
  }
}
